import React from 'react';
import {Modal} from 'antd';
import style from '../../assets/style/tipDialog.scss'

const TipDialog = ({
                       title = '提示',
                       modalWidth = 520,
                       open,
                       onClose,
                       children
                   }) => {
        return (
            <Modal
                centered
                open={open}
                width={modalWidth}
                footer={null}
                closable={false}
                className='tip-dialog'
                maskClosable={true}
                onCancel={onClose}
            >
                <div className='modal-title'>
                    <div>{title}</div>
                    <div className='btn-animate-close' onClick={onClose}>
                        <div className='wrap'>
                            <div className='icon-close-white'></div>
                            <div className='icon-close-blue'></div>
                        </div>
                    </div>
                </div>
                <div className='modal-content'>{children}</div>
            </Modal>
        );
    }
;

export default TipDialog;
